import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Headers, Http, RequestOptions} from "@angular/http";
import {Configuration} from '../config/config';
import 'rxjs/add/operator/map';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class CreateCommunityService {
  public jwtToken: string;
 
  constructor(private httpClient:HttpClient, private http: Http) {
    const theUser:any = JSON.parse(localStorage.getItem('currentUser'));
    if (theUser) {
      this.jwtToken = theUser.token;
    }
  }

 
  refreshToken(){
    const theUser:any = JSON.parse(localStorage.getItem('currentUser'));
    if (theUser) {
      this.jwtToken = theUser.token;
    }
  }
//   getAllCommByUserName(currentUser){

// //var  headers_object=new HttpHeaders().set("Authorization",this.jwtToken);
// var headers_object = new HttpHeaders({
//   'Content-Type': 'application/json',
//    'Authorization':"Bearer"+this.jwtToken
// });

// const httpOptions = {
//   headers: headers_object
// };
// this.http.post(
//   Configuration.ServerWithApiUrl + '/AllComunities', httpOptions
//  ).subscribe(resp => {
//  console.log(resp.json());
//   }
// );
 // }
 getAllCommNamesForSuperAdmin(){
  return this.httpClient.get(Configuration.ServerWithApiUrl+'/communitiesnames')
  .map((res: any)=>res);
 }
  getAllCommunity(){


    return this.httpClient.get(Configuration.ServerWithApiUrl+'/AllComunities')
      .map((res: any)=>res)
  }

  getAllCommRole(){


    return this.httpClient.get(Configuration.ServerWithApiUrl+'/getAllCommRole')
      .map((res: any)=>res)
  }

  getAllBusinessUnit(){


    return this.httpClient.get(Configuration.ServerWithApiUrl+'/getAllBusinessUnit')
      .map((res: any)=>res)

  }

  saveCommunity(communityObj){

    return this.httpClient.post(Configuration.ServerWithApiUrl+'/communities', communityObj)
      .map((res: any)=>res)

  }

  deleteCommunity(data){

    return this.httpClient.put(Configuration.ServerWithApiUrl+'/deleteCommunity',data)
      .map((res: any)=>res)

  }

  getUserByCommunityId(comm_id){

    return this.httpClient.get(Configuration.ServerWithApiUrl+'/getAllAdmins/'+comm_id)
      .map((res: any)=>res)

  }

  updateUserCommunity(data){

    return this.httpClient.put(Configuration.ServerWithApiUrl+'/assignAdmin',data)
      .map((res: any)=>res)

  }

  getAllOrganizations(){

    return this.httpClient.get(Configuration.ServerWithApiUrl+'/organizations')
      .map((res: any) => res)

  }

  activateCommunity(Obj){

    return this.httpClient.post(Configuration.ServerWithApiUrl+'/community/activate', Obj)
      .map((res: any) => res)

  }

  getCommunityByCommunityID(communityID){


    return this.httpClient.get(Configuration.ServerWithApiUrl+'/communities/'+communityID)
      .map((res: any)=>res)

  }
  getCommunityByID(communityID){

    return this.httpClient.get(Configuration.ServerWithApiUrl+'/getCommunityWithOrganization/'+communityID)
      .map((res: any)=>res)

  }
  updateCommunityByID(community){


    return this.httpClient.put(Configuration.ServerWithApiUrl+'/updateCommunityWithOrganization',community)
      .map((res: any)=>res)

  }

  changeConfiguration(Obj){

    return this.httpClient.post(Configuration.ServerWithApiUrl+'/community/config', Obj)
      .map((res: any) => res)

  }

  changeKYCConfiguration(Obj){

    return this.httpClient.post(Configuration.ServerWithApiUrl+'/community/kycConfig', Obj)
      .map((res: any) => res)

  }

  checkPassword(obj){

    return this.httpClient.post(Configuration.ServerWithApiUrl+ '/confirmPassword', obj)
      .map((res: any) => res)

  }

  getAllCourses(){

    return this.httpClient.get(Configuration.ServerWithApiUrl+ '/getAllCoursesToAssignCommunity')
      .map((res: any) => res)

  }

  getAllCertificates(){


    return this.httpClient.get(Configuration.ServerWithApiUrl+ '/certificate')
      .map((res: any) => res)

  }

  addContentToCommunity(obj){


    return this.httpClient.put(Configuration.ServerWithApiUrl+ '/community/content',obj)
      .map((res: any) => res)

  }

  getCommunityByIdForContent(id){


    return this.httpClient.get(Configuration.ServerWithApiUrl+'/community_content/'+id)
      .map((res: any)=>res)

  }

  getCertificateById(id){
    return this.httpClient.get(Configuration.ServerWithApiUrl + '/certificate_det/'+id )
      .map((res: any) => res)

  }

  getCertificateConfigById(id, community_id){
    return this.httpClient.get(Configuration.ServerWithApiUrl + '/certificate_config/'+id + '/'+community_id)
      .map((res: any) => res)

  }

  saveStepTransaction(obj){

    return this.httpClient.post(Configuration.ServerWithApiUrl + '/certificate_config_for_community', obj)
      .map((res: any) => res)

  }

  generateClientId(commid){

    return this.httpClient.get(Configuration.ServerWithApiUrl + '/generateClientId/'+commid)
      .map((res: any) => res)

  }

  getCommunityLicensesContent(commid){

    return this.httpClient.get(Configuration.ServerWithApiUrl + '/getCommunityLicensesContent/'+commid)
      .map((res: any) => res)

  }

  getResourceConfiguration(commid){
    return this.httpClient.get(Configuration.ServerWithApiUrl + '/getResourceConfig/'+commid)
      .map((res: any) => res)
  }

  saveResourceConfig(Obj){
    return this.httpClient.post(Configuration.ServerWithApiUrl+'/saveResourceConfig', Obj)
      .map((res: any) => res)
  }

  uploadResJSONFile(data){
    return this.httpClient.post(Configuration.ServerWithApiUrl+ '/uploadCommResourceFile', data)
      .map((res : any)=> res);
  }

  checkResZipFile(data, id){
    const headers = new Headers();
    // headers.append('Content-Type', 'application/json');
    headers.append('Cache-Control', 'no-cache');
    headers.append('Pragma', 'no-cache');
    headers.append('Authorization', `${this.jwtToken}`);
    let options =new RequestOptions( {headers: headers});

    return this.http.post(Configuration.ServerWithApiUrl+ '/checkCommResourceFile/'+id, data, options)
      .map(res => res.json());
  }

  uploadResIconZipFile(data, id){
    const headers = new Headers();
    // headers.append('Content-Type', 'application/json');
    headers.append('Cache-Control', 'no-cache');
    headers.append('Pragma', 'no-cache');
    headers.append('Authorization', `${this.jwtToken}`);
    let options =new RequestOptions( {headers: headers});

    return this.http.post(Configuration.ServerWithApiUrl+ '/uploadCommResourceIcon/'+id, data, options)
      .map(res => res.json());
  }

  getGameStyleFile(commId){
    return this.httpClient.get(Configuration.ServerWithApiUrl + '/getGameStyleFile/'+ commId)
      .map((res: any) => res)
  }

  saveStyleConfig(Obj){
    return this.httpClient.post(Configuration.ServerWithApiUrl+'/saveCommStyleConfig', Obj)
      .map((res: any) => res)
  }

  getAllJourneyContent(){
    return this.httpClient.get(Configuration.ServerWithApiUrl+ '/journey')
      .map((res: any) => res)
  }

  validateJourneyContentForComm(Obj){
    return this.httpClient.post(Configuration.ServerWithApiUrl+'/validJourneyContentForComm', Obj)
      .map((res: any) => res)
  }

  getAllPublishedJourneys(){
    return this.httpClient.get(Configuration.ServerWithApiUrl+'/publishedJourney')
      .map((res: any)=>res)
  }

  
  getConfigureEmail(commid){
    // alert("in service call line");
    return this.httpClient.get(Configuration.ServerWithApiUrl + '/getConfigureEmailList/'+commid)
      .map((res: any) => res)
  }

  getConfigureEmailWithoutToken(commid){
    // alert("in service call line");
    return this.httpClient.get(Configuration.ServerWithApiUrl + '/getConfigureEmailWithoutToken/'+commid)
      .map((res: any) => res)
  }

  saveConfigureEmail(obj){
    return this.httpClient.post(Configuration.ServerWithApiUrl + '/addConfigureEmail', obj)
      .map((res: any) => res)
  }

  updateConfigureEmail(obj){
    return this.httpClient.post(Configuration.ServerWithApiUrl + '/updateConfigureEmail', obj)
      .map((res: any) => res)
  }

  deleteConfigureEmailDataByID(config_email_id){
    return this.httpClient.get(Configuration.ServerWithApiUrl + '/deleteConfigureEmailDataByID/'+config_email_id)
      .map((res: any) => res)
  }

  createAuthConfgurationSSO(obj){

    if(obj.cognitoUserPool === null){
      obj.cognitoUserPool = "";
    }
    return this.httpClient.post(Configuration.ServerWithApiUrl + '/sso_auth',obj )
      .map((res: any) => res)
  }
  getDatafromCommunityID(obj){
    return this.httpClient.post(Configuration.ServerWithApiUrl + '/sso_info',obj )
      .map((res: any) => res)
  }

  getCommIdByClientId(obj){

    return this.httpClient.get(Configuration.ServerWithApiUrl + '/getCommIdByClientId/'+obj.client_id)
      .map((res: any) => res)
  }
  subDomainExistInCommunity(obj){
    return this.httpClient.post(Configuration.ServerWithApiUrl + '/IsSubdomainexist',obj )
      .map((res: any) => res)
  }
}



// WEBPACK FOOTER //
// ./src/app/Services/create-community.service.ts